import { api, ApiError } from "../api.ts";
import { h, setMsg } from "../dom.ts";
import { t } from "../i18n/index.ts";
import { navigate, type Params } from "../router.ts";
import { refreshUser } from "../session.ts";
import { brandLockup, BRAND_NAME } from "../ui/brand.ts";

/** Reset-password landing (`/reset/:token`): the emailed link opens here. Pick a
 *  new password; on success the member is signed in and dropped home. */
export function resetScreen(params: Params): HTMLElement {
  const token = params.token ?? "";

  const el = h(`
    <main class="card">
      <h1 class="brand" aria-label="${BRAND_NAME}">${brandLockup}</h1>
      <p class="tagline">${t("reset.tagline")}</p>
      <form novalidate>
        <label class="field">
          <span>${t("reset.label")}</span>
          <input name="password" type="password" autocomplete="new-password" autofocus required />
        </label>
        <button class="btn primary" type="submit">${t("reset.submit")}</button>
        <p class="msg" role="status" aria-live="polite"></p>
      </form>
      <p class="fine"><a data-link href="/login">${t("forgot.back")}</a></p>
    </main>
  `);

  const form = el.querySelector("form")!;
  const msg = el.querySelector(".msg") as HTMLElement;
  const button = el.querySelector("button") as HTMLButtonElement;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const password = String(new FormData(form).get("password") ?? "");
    if (password.length < 8) {
      setMsg(msg, t("reset.min"), "bad");
      return;
    }
    button.disabled = true;
    setMsg(msg, t("reset.saving"));
    try {
      await api.resetPassword(token, password);
      await refreshUser(); // the reset response set our session cookie
      navigate("/");
    } catch (err) {
      setMsg(msg, err instanceof ApiError ? err.message : t("reset.failed"), "bad");
      button.disabled = false;
    }
  });

  return el;
}
